import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "list"];

  toggleForm() {
    this.formTarget.classList.toggle("hidden");
  }

  cancel() {
    this.formTarget.classList.add("hidden");
  }

  toggleReply(event) {
    const form = this.findReplyForm(event);
    if (!form) return;

    form.classList.toggle("hidden");
  }

  cancelReply(event) {
    const form = this.findReplyForm(event);
    if (!form) return;

    form.classList.add("hidden");
  }

  submit() {
    // Submit form via Turbo
    this.element.closest("form").requestSubmit();
  }

  resetForm(event) {
    if (!event.detail.success) return;

    event.target.reset();

    const replyForm = event.target.closest("[data-comment-reply-form]");
    if (replyForm) replyForm.classList.add("hidden");
  }

  findReplyForm(event) {
    const formId = event.currentTarget.dataset.commentsReplyFormId;
    if (!formId) return null;

    return document.getElementById(formId);
  }
}
